import saveData from '../../api/userActividad'
import swal from 'sweetalert'
import router from '../../router'
const SECRET = 'e2ab018979a3c007014c10efb3b0c3fe'
var jwt = require('jsonwebtoken')

const state = {
  actividad: [],
  modulos: [],
  marquesina: [],
  miAgenda: []
}

const getters = {
  actividades (state) {
    return state.actividad
  },
  modulosActivos (state) {
    return state.modulos
  },
  marquesina (state) {
    return state.marquesina
  },
  miAgenda (state) {
    return state.miAgenda
  }
}

const actions = {
  setTime (context, params) {
    const token = localStorage.getItem('token')
    const subnet = localStorage.getItem('subnet')
    var decoded = jwt.verify(token, SECRET)
    var lapso1 = localStorage.getItem('timetoken')
    var lapso2 = lapso1 - 2
    setInterval(() => {
      swal({
        title: 'Sesión Proxima a Expirar',
        text: 'A su sesión le faltan 2 minutos por terminar ¿Desea continuar con esta sesión activa?',
        buttons: true,
        successMode: true
      })
        .then((willDelete) => {
          var currentTime = new Date().getTime() / 1000
          var difcreated = (decoded.exp - decoded.iat) / 60 // obtenemos minutos
          var difexp = (currentTime - decoded.iat) / 60 // obtenemos minutos faltantes
          var dif = difcreated - difexp
          if (willDelete) {
            if (dif > 0) {
              swal('Su sesión seguirá activa durante los proximos ' + lapso1 + ' min')
              // console.log('Agregar el tiempo al token')
              var datos = decoded.data
              var userId = {
                data: datos
              }
              var newToken = jwt.sign(userId, SECRET, {
                expiresIn: parseInt(lapso1) * 60
              })
              localStorage.setItem('token', newToken)
            } else {
              swal('La sesión ha expirado por inactividad. Vuelva a iniciar sesion')
              router.push({ path: '/' + subnet })
              localStorage.removeItem('token')
            }
          } else {
            swal('La sesión puede cerrarse en cualquier momento y tendrá que identificarse nuevamente. \n \n IMPORTANTE: Recuerde que este tiempo puede perderse')
          }
        })
    }, (1000 * 60) * lapso2)
  },
  async setActividad (context, params) {
    context.commit('SETACTIVIDAD', params)
    let index = context.state.actividad.length
    let observador = []
    if (localStorage.getItem('Observador')) {
      observador = JSON.parse(localStorage.getItem('Observador'))
    } else {
      observador = []
    }
    if (
      index >= 3 ||
      observador.length >= 3 ||
      params.accion === 'Va a salir' ||
      params.accion === 'Mi cuenta' ||
      params.accion === 'Adicion'
    ) {
      await saveData
        .sendData(localStorage.getItem('subnet'), state.actividad)
        .then(x => {
          let titulo = x.data[0].valueitem
          localStorage.setItem('marquesina', titulo)
          // this.$store.dispatch('fachada/MARQUESINA', titulo)
          context.commit('CLEARACTIVIDAD', params)
          localStorage.setItem('Observador', [])
          // console.log('Respondio y la long de act es' + state.actividad.length)
        })
        .catch(err => {
          console.log('Error' + err)
        })
    }
  },
  clearActividad (context, params) {
    context.commit('CLEARACTIVIDAD', params)
  },
  setModulos (context, params) {
    context.commit('SETMODULOSACTIVOS', params)
  },
  clearModulos (context, params) {
    context.commit('CLEARMODULOSACTIVOS', params)
  },
  setMarquesina (context, params) {
    context.commit('setMarquesina', params)
  },
  setMiAgenda (context, params) {
    context.commit('setMiAgenda', params)
  }
}

const mutations = {
  SETACTIVIDAD (state, params) {
    var insertActividad = JSON.parse(JSON.stringify(params))
    var moduloActividad = insertActividad.modulo
    var agregarActividad = false
    var observador = []
    // console.log('--------setactividad---------')
    agregarActividad = state.modulos.find(item => {
      return item === moduloActividad
    })
    if (agregarActividad) {
      // console.log('Agregando actividad en ' +insertActividad.modulo)
      state.actividad.push(insertActividad)
      if (localStorage.getItem('Observador')) {
        observador = JSON.parse(localStorage.getItem('Observador'))
      } else {
        observador = []
      }
      observador.push(insertActividad)
      localStorage.setItem('Observador', JSON.stringify(observador))
    } else {
      var isStand = moduloActividad.substring(0, 5)
      // console.log('Es Stand ?' + isStand)
      if (isStand === 'Stand') {
        agregarActividad = state.modulos.find(item => {
          return item === 'Stand'
        })
        if (agregarActividad) {
          // console.log('Es Stand agrega actividad :' +insertActividad.modulo)
          state.actividad.push(insertActividad)
          if (localStorage.getItem('Observador')) {
            observador = JSON.parse(localStorage.getItem('Observador'))
          } else {
            observador = []
          }
          // console.log('Tam observador' + observador.length)
          observador.push(insertActividad)
          console.log(observador)
          localStorage.setItem('Observador', JSON.stringify(observador))
        }
      }
    }
    // console.log('-----------------------------')
  },
  CLEARACTIVIDAD (state, params) {
    state.actividad = []
  },
  SETMODULOSACTIVOS (state, params) {
    // console.log(JSON.stringify(params))
    params.map(item => {
      if (item.valueitem === 'true') {
        state.modulos.push(item.keyitem)
      }
    })
    localStorage.setItem('modulos', JSON.stringify(state.modulos))
  },
  CLEARMODULOSACTIVOS (state, params) {
    state.modulos = []
  },
  setMarquesina (state, params) {
    const data = !params ? [] : params
    state.marquesina = data
  },
  setMiAgenda (state, params) {
    state.miAgenda = params
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js